"use client";

import React, { useState } from "react";

import { MinusIcon, PlusIcon } from "@shared/ui.icons";
import { getRegion } from "@shared/utils.locale";
import type { LocaleOfStoreType } from "@beautypie/core";
import { color } from "lib/theme/theme.css";
import type { FooterCategory } from "@shared/graphql.types";

import { FooterMenuItem } from "../FooterMenuItem";
import { CookiePreferenceButton } from "../FooterMenuItem/CookiePreferenceButton";
import { ZendeskFooterMenuItem } from "../FooterMenuItem/ZendeskFooterMenuItem";

import {
  accordion,
  accordionButton,
  accordionButtonTitle,
  accordionButtonWrapper,
  accordionItem,
  accordionPanel
} from "./MobileFooterAccordion.css";

interface Props {
  footerItems: FooterCategory[];
  locale: LocaleOfStoreType;
}

export const MobileFooterAccordion: React.FC<Props> = ({
  footerItems,
  locale
}) => {
  const userRegion = getRegion(locale);
  const [expandedItemIndex, setExpandedItemIndex] = useState<number | null>(
    null
  );

  const handleAccordionItemClick = (index: number) => {
    if (expandedItemIndex === index) {
      setExpandedItemIndex(null);
    } else {
      setExpandedItemIndex(index);
    }
  };

  return (
    <div className={accordion} data-testid="MobileFooterAccordion">
      {footerItems.map((item, index) => {
        const { title, items = [] } = item;

        const isExpanded = expandedItemIndex === index;

        return (
          <div className={accordionItem} key={`AccordionItem-${title}`}>
            <h2 id={title}>
              <button
                type="button"
                className={accordionButton}
                onClick={() => handleAccordionItemClick(index)}
              >
                <div className={accordionButtonWrapper}>
                  <h3 className={accordionButtonTitle}>{title}</h3>
                </div>
                {isExpanded ? (
                  <MinusIcon fontSize="20px" color={color.contentSecondary} />
                ) : (
                  <PlusIcon fontSize="20px" color={color.contentSecondary} />
                )}
              </button>
              {isExpanded && (
                <div className={accordionPanel} data-testid="AccordionPanel">
                  {items.map((footerItem) => {
                    const dataId = `DesktopFooterSubItem-${footerItem.title}`;

                    if (
                      footerItem.href.includes("#onetrust-preference-banner")
                    ) {
                      return (
                        <CookiePreferenceButton
                          data-testid={dataId}
                          key={footerItem.title}
                          item={footerItem}
                          region={userRegion}
                        />
                      );
                    }

                    if (footerItem.href.startsWith("https://beautypiehelp")) {
                      return (
                        <ZendeskFooterMenuItem
                          key={footerItem.title}
                          data-testid={dataId}
                          item={footerItem}
                        />
                      );
                    }

                    return (
                      <FooterMenuItem
                        key={footerItem.title}
                        data-testid={dataId}
                        item={footerItem}
                      />
                    );
                  })}
                </div>
              )}
            </h2>
          </div>
        );
      })}
    </div>
  );
};
